import React, { useState, useEffect } from "react";

const RunbookName = ({ name, editedName, sendDataToParent, userUpdated, editable }) => {
  const [localName, setLocalName] = useState(editedName !== "" ? editedName : ("Runbook to resolve issues with " + name));

  useEffect(() => {
    setLocalName(editedName !== "" ? editedName : ("Runbook to resolve issues with " + name));
  }, [name, editedName]);

  const handleChange = (e) => {
    setLocalName(e.target.value);
  };

  const handleSave = () => {
    sendDataToParent(localName);
  };

  return (
    <React.Fragment>
      <div className="d-flex flex-row align-items-center">
        <h1
          className="text-center my-0 mb-3"
          style={{ fontSize: "1.2rem", color: "#DBE1F5" }}>
          {"Runbook for the Alert"}
          {!userUpdated && (
            <img
              src="/icons/ai-compressed.png"
              alt="Customize Icon"
              className="me-4 ms-2 ai-svg-icon"
            />
          )}
        </h1>
      </div>
    </React.Fragment>
  );
}

export default RunbookName;